import { useState } from 'react';
import { useDebounce } from '@hooks/useDebounce';
import { useCxTestPatients } from '@hooks/useCallExperience';
import { parseApiError } from '@utils/errorUtils';

export const PRODUCT_LINE_NAMES = { 1: 'CPAP', 2: 'CGM' };

/** Search the company's patients by name, account number or phone and pick one. */
export default function PatientPicker({ companyId, selected, onSelect, productLineId, autoFocus = true }) {
  const [query, setQuery] = useState('');
  const debounced = useDebounce(query, 300);
  const { data: patients = [], isFetching, error } = useCxTestPatients(companyId, debounced);

  if (selected) {
    return (
      <div className="cx-tc-picked">
        <PatientSummary patient={selected} productLineId={productLineId} />
        <button type="button" className="cx-btn cx-btn-small" onClick={() => onSelect(null)}>Change</button>
      </div>
    );
  }
  return (
    <div>
      <input className="cx-input-full cx-tc-input" placeholder="Name, account number or phone" value={query}
        onChange={(e) => setQuery(e.target.value)} aria-label="Find a patient" autoFocus={autoFocus} />
      {error && <div className="cx-error">{parseApiError(error)}</div>}
      {debounced.trim().length >= 2 && (
        <ul className="cx-tc-results">
          {patients.map((p) => (
            <li key={p.guid}>
              <button type="button" onClick={() => onSelect(p)}><PatientSummary patient={p} productLineId={productLineId} /></button>
            </li>
          ))}
          {!isFetching && patients.length === 0 && <li className="cx-muted cx-small">No patients of this company match.</li>}
        </ul>
      )}
    </div>
  );
}

export function PatientSummary({ patient, productLineId }) {
  const missingLine = productLineId && !patient.productLines.includes(productLineId);
  return (
    <span className="cx-tc-patient">
      <b>{patient.name || 'No name'}</b>
      <span className="cx-muted cx-small">{[patient.accountNumber, patient.phoneNumber].filter(Boolean).join(' · ')}</span>
      {patient.productLines.map((id) => <span key={id} className="cx-badge cx-badge-gl">{PRODUCT_LINE_NAMES[id] || id}</span>)}
      {patient.spanish && <span className="cx-badge cx-badge-par">Spanish</span>}
      {!patient.active && <span className="cx-badge cx-badge-off">inactive</span>}
      {missingLine && <span className="cx-badge cx-badge-warn">no {PRODUCT_LINE_NAMES[productLineId]}</span>}
    </span>
  );
}
